export default "__VITE_ASSET__5bd907f7__"